module.exports = __webpack_public_path__ + "static/media/hall-P12.d42290d9.svg";